Ext.define('SA.VectorMapExportPage', {
    singleton: true,

    async getBusinessPoints(modelState) {
        if (!modelState.businessSearch) {
            return SA.GeoJson.createEmptyFeatureCollection();
        }

        var response = await fetch(SA.VectorMapBusinessPointsGeoJsonSourceData.get(modelState, {enableServerSideClustering: false}));

        if (!response.ok) {
            let {exceptionClass} = await response.json();

            if (exceptionClass.endsWith('TooManyPointsException')) {
                response = await fetch(SA.VectorMapBusinessPointsGeoJsonSourceData.get(modelState, {enableServerSideClustering: true}));

                if (!response.ok) {
                    let {exceptionClass} = await response.json();

                    if (exceptionClass.endsWith('TooManyClusterPointsException')) {
                        return SA.GeoJson.createEmptyFeatureCollection();
                    }
                }
            }
        }

        return await response.json();
    },

    async getCanvas({insetMap, legend, northArrow, pageHeight, pageWidth, scaleBar, textLabels, thematicMap}) {
        var businesses = await this.getBusinessPoints(thematicMap.modelState),
            maxExtent = thematicMap.modelState.maxExtent,
            params = [thematicMap],
            images = [
                SA.VectorMapExportThematicMap.getCanvas({
                    attributionText: SA.VectorMapConstants.getAttributionText(),
                    geoJsonSourcesData: {...SA.VectorMapThematicMapGeoJsonSourcesData.get(thematicMap.modelState, {enableServerSideClustering: false}), businesses},
                    layersProperties: SA.VectorMapThematicMapLayersProperties.get(thematicMap.modelState),
                    maxExtent,
                    params: thematicMap,
                    style: SA.VectorMapConstants.getThematicMapStyle(),
                    styleBaseUrls: SA.VectorMapConstants.getThematicMapStyleBaseUrls(),
                    tileSourcesUrls: SA.VectorMapThematicMapTileSourcesUrls.get(thematicMap.modelState)
                })
            ];

        if (northArrow.visible) {
            params.push(northArrow);

            images.push(SA.Svg.toImageElement(SA.VectorMapExportNorthArrow.getSvg(northArrow)));
        }

        if (insetMap.visible) {
            params.push(insetMap);

            images.push(SA.VectorMapExportInsetMap.getCanvas({
                maxExtent,
                params: insetMap,
                scale: SA.VectorMapConstants.getExportInsetMapExtentScale(),
                style: SA.VectorMapConstants.getInsetMapStyle()
            }));
        }

        if (scaleBar.visible) {
            params.push(scaleBar);

            images.push(SA.Svg.toImageElement(SA.VectorMapExportScaleBar.getSvg(scaleBar)));
        }

        if (legend.visible) {
            params.push(legend);

            images.push(SA.Svg.toImageElement(SA.VectorMapExportLegend.getSvg(legend)));
        };

        textLabels.forEach(textLabel => {
            params.push(textLabel);

            images.push(SA.Svg.toImageElement(SA.VectorMapExportTextLabel.getSvg(textLabel)));
        });

        return new SA.CanvasRenderer().render({
            background: '#fff',
            height: pageHeight,
            width: pageWidth,

            content: await Promise.all(images).then(images => images.map((source, i) => ({
                type: 'image',
                source,
                ...resolveXY(params[i], source)
            })))
        }).getCanvas();

        function resolveXY({x, y, ...params}, canvasImageSource) {
            return {
                ...params,
                x: x * (pageWidth - canvasImageSource.width),
                y: y * (pageHeight - canvasImageSource.height)
            };
        }
    }
});